module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.674f50d.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome-webfont.eot
// module id = aPsI
// module chunks = 1